import React, { useState, useEffect } from "react";
import { FaTimes, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./eventgallery.css"; // Your CSS for gallery styling
import img1 from "../../assets/gallery/1 (1).jpg";
import img2 from "../../assets/gallery/1 (2).jpg";
import img3 from "../../assets/gallery/1 (3).jpg";
import img4 from "../../assets/gallery/1 (4).jpg";
import img5 from "../../assets/gallery/1 (5).jpg";
import img6 from "../../assets/gallery/1 (6).jpg";
import img7 from "../../assets/gallery/1 (7).jpg";
import img8 from "../../assets/gallery/1 (8).jpg";
import img9 from "../../assets/gallery/1 (9).jpg";
import img10 from "../../assets/gallery/1 (10).jpg";
import img11 from "../../assets/gallery/1 (11).jpg";
import img12 from "../../assets/gallery/1 (12).jpg";
import img13 from "../../assets/gallery/1 (13).jpg";
import img14 from "../../assets/gallery/1 (14).jpg";
import img15 from "../../assets/gallery/1 (15).jpg";
import img16 from "../../assets/gallery/1 (16).jpg";
import img17 from "../../assets/gallery/1 (17).jpg";
import img18 from "../../assets/gallery/1 (18).jpg";
import img19 from "../../assets/gallery/1 (19).jpg";
import img20 from "../../assets/gallery/1 (20).jpg";
import img21 from "../../assets/gallery/1 (21).jpg";
import img22 from "../../assets/gallery/1 (22).jpg";
import img23 from "../../assets/gallery/1 (23).jpg";
import img24 from "../../assets/gallery/1 (24).jpg";
import img25 from "../../assets/gallery/1 (25).jpg";
import img26 from "../../assets/gallery/1 (26).jpg";
import img27 from "../../assets/gallery/1 (27).jpg";
import img28 from "../../assets/gallery/1 (28).jpg";
import img29 from "../../assets/gallery/1 (29).jpg";
import img30 from "../../assets/gallery/1 (30).jpg";
import img31 from "../../assets/gallery/1 (31).jpg";
import img32 from "../../assets/gallery/1 (32).jpg";
import img33 from "../../assets/gallery/1 (33).jpg";
import img34 from "../../assets/gallery/1 (34).jpg";
import img35 from "../../assets/gallery/1 (35).jpg";
import img36 from "../../assets/gallery/1 (36).jpg";
import img37 from "../../assets/gallery/1 (37).jpg";
import img38 from "../../assets/gallery/1 (38).jpg";
import img39 from "../../assets/gallery/1 (39).jpg";
import img40 from "../../assets/gallery/1 (40).jpg";
import img41 from "../../assets/gallery/1 (41).jpg";
import img42 from "../../assets/gallery/1 (42).jpg";
import img43 from "../../assets/gallery/1 (43).jpg";
import img44 from "../../assets/gallery/1 (44).jpg";
import img45 from "../../assets/gallery/1 (45).jpg";
import img46 from "../../assets/gallery/1 (46).jpg";
import img47 from "../../assets/gallery/1 (47).jpg";
import img48 from "../../assets/gallery/1 (48).jpg";
import img49 from "../../assets/gallery/1 (49).jpg";
import img50 from "../../assets/gallery/1 (50).jpg";
import img51 from "../../assets/gallery/1 (51).jpg";
import img52 from "../../assets/gallery/1 (52).jpg";
import img53 from "../../assets/gallery/1 (53).jpg";
import img54 from "../../assets/gallery/1 (54).jpg";
import img55 from "../../assets/gallery/1 (55).jpg";
import img56 from "../../assets/gallery/1 (56).jpg";
import img57 from "../../assets/gallery/1 (57).jpg";
import img58 from "../../assets/gallery/1 (58).jpg";
import img59 from "../../assets/gallery/1 (59).jpeg";

const GallerySection = ({ images = [  img13, img12, img11, img59, img16, img54, img4, img5, img6, img7, img8, img9, img10,
  img3, img28, img1, img14, img15, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27, img2, img29, img30,
  img31, img32, img33, img34, img35, img36, img37, img38, img39, img40,
  img41, img42, img43, img44, img45, img46, img47, img48, img49, img50,
  img51, img52, img53, img55, img56, img57, img58] }) => {
  const [visibleCount, setVisibleCount] = useState(4);
  const [popupIndex, setPopupIndex] = useState(null);

  const loadMoreImages = () => {
    setVisibleCount((prev) => prev + 4);
  };

  const openPopup = (index) => {
    setPopupIndex(index);
  };

  const closePopup = () => {
    setPopupIndex(null);
  };

  const prevImage = () => {
    setPopupIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const nextImage = () => {
    setPopupIndex((prev) => (prev < images.length - 1 ? prev + 1 : prev));
  };

  const handleKeyDown = (e) => {
    if (popupIndex !== null) {
      if (e.key === "ArrowLeft") prevImage();
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "Escape") closePopup();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  });

  return (
    <section className="gallery-section">
        <h2 className="gallery-title">Our Latest Events</h2>
      <div className="gallery-grid">
        {images.slice(0, visibleCount).map((img, index) => (
          <div
            key={index}
            className="gallery-card"
            onClick={() => openPopup(index)}
          >
            <img src={img} alt={`Gallery ${index}`} className="gallery-image" />
          </div>
        ))}
      </div>

      {visibleCount < images.length && (
        <div className="gallery-loadmore-wrapper">
          <button className="gallery-loadmore-btn" onClick={loadMoreImages}>
            Load More
          </button>
        </div>
      )}

      {popupIndex !== null && (
        <div className="gallery-popup-overlay" onClick={closePopup}>
          <div
            className="gallery-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="gallery-popup-close" onClick={closePopup}>
              <FaTimes />
            </button>

            <button
              className="gallery-popup-prev"
              onClick={prevImage}
              disabled={popupIndex === 0}
            >
              <FaArrowLeft />
            </button>

            <img
              src={images[popupIndex]}
              alt={`Gallery ${popupIndex}`}
              className="gallery-popup-image"
            />

            <button
              className="gallery-popup-next"
              onClick={nextImage}
              disabled={popupIndex === images.length - 1}
            >
              <FaArrowRight />
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
